module.exports = __webpack_public_path__ + "img/xhs02.5192cab5.png";